var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 220,
    viewBox: "0 0 178 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC81C\\uC678_3",
    "data-name": "\\uC81C\\uC678 3",
    d: "M-5115.475,220a84.686,84.686,0,0,1-32.881-6.571,84.745,84.745,0,0,1-14.349-7.71,84.86,84.86,0,0,1-12.5-10.211,84.433,84.433,0,0,1-10.315-12.376,83.4,83.4,0,0,1-7.789-14.2,82.37,82.37,0,0,1-6.638-32.549,82.749,82.749,0,0,1,4.378-26.642,83,83,0,0,1,12.183-23.094,47.077,47.077,0,0,0,21.151,4.94c22.9,0,42.773-16.69,46.225-38.822a84.1,84.1,0,0,0-67.375,33.881,46.577,46.577,0,0,1-18.506-16.572A44.971,44.971,0,0,1-5209,45.791a44.689,44.689,0,0,1,3.675-17.824A45.6,45.6,0,0,1-5195.3,13.412,46.674,46.674,0,0,1-5180.439,3.6a47.317,47.317,0,0,1,18.2-3.6,47.318,47.318,0,0,1,18.2,3.6,46.67,46.67,0,0,1,14.864,9.814,45.584,45.584,0,0,1,10.022,14.555,44.689,44.689,0,0,1,3.675,17.824,45.463,45.463,0,0,1-.538,6.971h.538a84.682,84.682,0,0,1,32.881,6.571,84.744,84.744,0,0,1,14.349,7.71,84.9,84.9,0,0,1,12.5,10.211,84.435,84.435,0,0,1,10.315,12.376,83.4,83.4,0,0,1,7.789,14.2A82.369,82.369,0,0,1-5031,136.38a82.369,82.369,0,0,1-6.638,32.549,83.4,83.4,0,0,1-7.789,14.2,84.433,84.433,0,0,1-10.315,12.376,84.9,84.9,0,0,1-12.5,10.211,84.745,84.745,0,0,1-14.349,7.71A84.682,84.682,0,0,1-5115.475,220Z",
    transform: "translate(5209)",
    fill: "#b1e7e7",
    opacity: 0.35
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCir);
export default __webpack_public_path__ + "static/media/blue_cir.24f1055f9afc2bcb1c7872e66ecce106.svg";
export { ForwardRef as ReactComponent };